import {useState, useEffect} from "react"

import './OtpRowItem.css';
import {generateTOTP, getProgress} from "./TotpUtils"

export default function OtpRowItem({ otpRow, onEdit }) {
  const { mName,  mSecret, mIssuer, mAlgorithm, mDigits, mPeriod, mIcon } = otpRow;

  const period = parseInt(mPeriod) || 30;
  const digits = parseInt(mDigits) || 6;
  const initials = mIssuer.substring(0,2).toUpperCase();

  const [otpcode, setOtpCode] = useState("------")
  const [progress, setProgress] = useState(100)
  const cardColor = localStorage.getItem('otpCardColor') || '#f8f8f8'

  const handleGoToTotpEdit = () => {
    onEdit(otpRow);
  }
  useEffect(() => {
    const updateCode = async () => {
      try {
        const otp = await generateTOTP(mSecret, mAlgorithm, mDigits, mPeriod)
        //console.log( "new OTP : " + otp )
        setOtpCode( otp )
      } catch(error) {
        setOtpCode("------")
      }
    }
    updateCode();

    let  prevProgress = progress;
    const updateProgress = () => {
      const curProgress = getProgress(period)
      setProgress(curProgress)

      if (curProgress > prevProgress ) {
        updateCode();
      }

      prevProgress = curProgress;
    }
    updateProgress();


    const interval = setInterval( updateProgress, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="otp-row-item" style={{ backgroundColor: cardColor }}>
      <div className="otp-header">
        <span className="otp-account">{mName}</span>
      </div>
      <div className="otp-progress-bar">
        <div
          className="otp-progress-fill"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <div className="otp-content">
        <div className="otp-disp-icon">
          <div className={`otp-initials ${mIcon ? "hide" : "" }`}>{initials}</div>
          <div className={`otp-initials ${mIcon ? "" : "hide" }`}>
            <img src={`${process.env.PUBLIC_URL}${mIcon}`} alt="icon" />
          </div>
        </div>

        <div className="otp-code">{otpcode}</div>
        <button className="otp-edit-btn" onClick={handleGoToTotpEdit}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
        </button>
      </div>
    </div>
  );
}